import MainLayout from '../layouts/main';
import StudentCoursesContainer from './container';

function studentCoursesPage() {
  return (
    <MainLayout>
      <StudentCoursesContainer/>
    </MainLayout>
  );
}

export default studentCoursesPage;
